import { Component, Input, OnInit } from '@angular/core';
import { TaskSubmission } from '../../../core/models/task-submission.model';
import { NgClass, DatePipe } from '@angular/common';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'app-client-task-submitted-prescription',
    templateUrl: './client-task-submitted-prescription.component.html',
    styleUrls: ['./client-task-submitted-prescription.component.scss'],
    imports: [FaIconComponent, NgClass, DatePipe]
})
export class ClientTaskSubmittedPrescriptionComponent implements OnInit {
  @Input() verified: boolean;
  @Input() rejected: boolean;
  @Input() submission: TaskSubmission;

  constructor() {}

  ngOnInit() {}
}
